import React, { useContext } from "react";
import Header from "../Header/Header";
import { AuthContext } from "../../contexts/AuthContext";
import Alertas from "./Alertas";

const ACCESOS = [
  { label: "Vinos", desc: "Catálogo, añadas, bodegas y fichas de cata", icon: "fas fa-wine-glass-alt", color: "#3b82f6", href: "/MenuArticulos", perm: "menu_articulos" },
  { label: "Compras", desc: "Órdenes de compra y recepciones", icon: "fas fa-file-signature", color: "#f59e0b", href: "/MenuCompras", perm: "menu_compras" },
  { label: "Ventas", desc: "Pedidos, surtidos y notas", icon: "fas fa-wine-bottle", color: "#10b981", href: "/MenuVentas", perm: "menu_ventas" },
  { label: "Inventarios", desc: "Existencias, disponible y kardex", icon: "fas fa-warehouse", color: "#64748b", href: "/MenuInventarios", perm: "menu_inventarios" },
  { label: "Admin", desc: "Cobranza, bancos y estados de cuenta", icon: "fas fa-coins", color: "#8b5cf6", href: "/MenuAdmin", perm: "configAdmin" },
  { label: "Reportes", desc: "Ventas, utilidad y dashboards", icon: "fas fa-chart-line", color: "#6366f1", href: "/MenuReportes", perm: "menu_reportes" },
];

function HomeInicio() {
  const { user } = useContext(AuthContext);
  const accesos = ACCESOS.filter((a) => !!user?.[a.perm]);
  const hora = new Date().getHours();
  const saludo = hora < 12 ? "Buenos días" : hora < 19 ? "Buenas tardes" : "Buenas noches";
  const fecha = new Date().toLocaleDateString("es-MX", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

  return (
    <>
      <Header />
      <div className="container-fluid" style={{ maxWidth: 1180, padding: "8px 20px 32px" }}>
        <div
          className="home-hero"
          style={{
            borderRadius: 16, padding: "28px 32px", marginBottom: 22, color: "#fff",
            background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 60%, #2563eb 100%)",
            boxShadow: "0 10px 30px rgba(30, 58, 138, 0.25)", position: "relative", overflow: "hidden",
          }}
        >
          <i className="fas fa-wine-glass-alt" style={{ position: "absolute", right: 24, bottom: -28, fontSize: "11rem", opacity: 0.09 }} />
          <div style={{ position: "relative" }}>
            <h2 style={{ margin: 0, color: "#fff" }}>
              {saludo}{user?.nombre ? `, ${user.nombre}` : ""}
            </h2>
            <p style={{ margin: "6px 0 0", color: "#bfdbfe", textTransform: "capitalize" }}>{fecha}</p>
          </div>
        </div>

        {user?.menu_reportes ? <Alertas /> : null}

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 14 }}>
          {accesos.map((a) => (
            <a key={a.href} href={a.href} className="card" style={{ padding: 16, textDecoration: "none", color: "inherit", borderTop: `3px solid ${a.color}` }}>
              <i className={a.icon} style={{ color: a.color, fontSize: "1.25rem", marginBottom: 8 }} />
              <strong>{a.label}</strong>
              <span style={{ color: "#64748b", fontSize: "0.78rem" }}>{a.desc}</span>
            </a>
          ))}
        </div>
      </div>
    </>
  );
}

export default HomeInicio;
